import FieldConfig from "../../../proto/field-config"
import FieldItemModelCalculatedExpenses_TableCell from "./render/table/table-cell"
import FieldCurrency from "../../../generic/finance/currency/currency"
import AggregateNumber from "../../../../fields/aggregate/aggregate-number"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"
import AggregateCost from "../../../../fields/system/cost/components/aggregate-cost"
import Task from "../../../../model2/task/task"
import Project from "../../../../model2/project/project"
import {SortDirection} from "../../../../data-structures/sort"
import ItemModelV2 from "../../../../model2/item2/item-model"
import {ItemModelV2_CalculatedValues} from "../../../../model2/item2/calculated/@type"


export default class FieldItemModelCalculatedExpenses extends FieldCurrency {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                              = "Expenses"
        this.label                                  = "Expenses"
        this.icon                                   = "i5-expenses-light"

        this.hasCalculatedValues                    = true

        this.renderComponents.tableCell             = FieldItemModelCalculatedExpenses_TableCell
        this.renderComponents.tableCellCalculated   = FieldItemModelCalculatedExpenses_TableCell
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [
                (listItem: ItemModelV2) => {
                    const dataByAggregateFunc = listItem.calculated.dataByAggregateFunction[this.fieldId]
                    const calculatedValues: ItemModelV2_CalculatedValues = dataByAggregateFunc?.[_.keys(dataByAggregateFunc)[0] as keyof {}] // take first property from dataByAggregateFunc

                    return calculatedValues?.total.value || 0
                }
            ],
            directions  : [sort]
        }
    }


    getAggregateValue(model:Task|Project) {
        return model.expensesCollection?.total
    }

    getAggregateClass() {
        return AggregateNumber
    }

    getDefaultAggregateFunction() {
        return AggregateFunctionType.SUM
    }

    getAggregateOptions() {return [
        AggregateFunctionType.SUM,
        AggregateFunctionType.MIN,
        AggregateFunctionType.MAX,
        AggregateFunctionType.MEDIAN,
        AggregateFunctionType.AVERAGE
    ]}

    get AggregateComponent() {
        return AggregateCost.bind(null, this.getAggregateOptions())
    }

}